import { render, staticRenderFns } from "./select-number-id.vue?vue&type=template&id=1a5f50d2&"
import script from "./select-number-id.vue?vue&type=script&lang=js&"
export * from "./select-number-id.vue?vue&type=script&lang=js&"
import style0 from "./select-number-id.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports